(function () {

    'use strict';

    class PlanProcedureStepsDialogCtrl {
        constructor($mdDialog, $translate, system, moment, configService) {
            this.moment = moment;
            this.dialog = $mdDialog;
            this.$translate = $translate
            this.configService = configService;

            this.currentStep = null;
            this.dateFormat = system['date_format'].js;
            this.timeFormat = system['time_format'].js;
            this.dateTimeFormat = system['datetime_format'].js;

            this.label = this.$translate.instant('dental_plan_procedure_steps_comment');
        }

        static get $inject() {
            return ["$mdDialog", "$translate", "system", "moment", "configService"];
        }

        $onInit() {
            this.procedure = this.procedure ? this.procedure : {};

            this.steps = this.handleSteps();
            this.currentStep = this.getCurrentStep();
            this.recalculateDateTime();

            this.promise = this.configService.get("dental_plan_step_dict", true)
                .then(dict_uid => {
                    this.field = {
                        label: this.label,
                        meta_data: {dict_uid}
                    };
                })
        }

        cancel() {
            this.dialog.cancel();
        }

        save() {
            let steps = _.map(this.steps, i => {
                if (i.fromStep) return _.omit(i, ['value', 'fromStep']);
                else return i;
            });

            this.dialog.hide(steps);
        }

        selectStep(step) {
            this.currentStep = step;
            this.recalculateDateTime();
        }

        getCurrentStep() {
            return _.chain(this.steps).find(i => !i.is_done).thru(i => i ? i : _.last(this.steps)).value();
        }

        addStep(ev) {
            let confirm = this.dialog.mnPromptDialog()
                .title('dental_plan_procedure_steps_add_new')
                .placeholder('dental_plan_procedure_steps_label')
                .targetEvent(ev);

            this.dialog.show(confirm)
                .then(value => {
                    let step = {value};
                    this.steps.push(step);
                    this.currentStep = step;
                });
        }

        isItemActive(item) {
            return _.isEqual(item, this.currentStep);
        }

        handleDone() {
            if (this.currentStep.is_done) {
                this.currentStep.date = this.moment().format(this.dateFormat);
                this.currentStep.time = this.moment().format(this.timeFormat);

                this.recalculateDoneAt();
            }
            else this.currentStep.done_at = null;
        }

        recalculateDoneAt() {
            const date = this.moment(this.currentStep.date, this.dateFormat);
            const time = this.moment(this.currentStep.time, this.timeFormat);

            this.currentStep.done_at = date.set({hours: time.hour(), minutes: time.minutes()}).format(this.dateTimeFormat);
        }

        recalculateDateTime() {
            if (_.get(this.currentStep, 'is_done', false)) {
                const datetime = this.moment(this.currentStep.done_at, this.dateTimeFormat);

                this.currentStep.date = datetime.format(this.dateFormat);
                this.currentStep.time = datetime.format(this.timeFormat);
            }
        }

        handleCommentChange() {
            if (_.isEmpty(this.currentStep.comment) && this.currentStep.is_done) {
                this.currentStep.is_done = false;
                this.handleDone();
            }

            if (!_.isEmpty(this.currentStep.comment) && !this.currentStep.is_done) {
                this.currentStep.is_done = true;
                this.handleDone();
            }
        }

        handleSteps() {
            return _.concat(
                this.handleFromSteps(), this.handleNotFromSteps()
            )
        }

        handleFromSteps() {
            return _.chain(this.procedure.steps).cloneDeep().map(item => {
                let stepComment = _.find(this.procedure['step_comments'], i => i['step_uid'] === item['step_uid']);
                if (stepComment) return _.chain(stepComment).assign(item, {fromStep: true}).value();
                else return _.assign(item, {fromStep: true});
            }).value();
        }

        handleNotFromSteps() {
            let stepIds = _.map(this.procedure.steps, 'step_uid');
            return _.chain(this.procedure['step_comments'])
                .filter(i => !_.includes(stepIds, i['step_uid']))
                .map(i => _.assign(i, {fromStep: false}))
                .value();
        }

        removeStep(step, ev) {
            let confirm = this.dialog.confirm()
                .multiple(true)
                .targetEvent(ev)
                .ariaLabel('remove step')
                .ok(this.$translate.instant('dental_module_ok'))
                .cancel(this.$translate.instant('dental_module_cancel'))
                .title(this.$translate.instant('dental_plan_procedure_steps_remove_confirm', step));

            this.dialog.show(confirm).then(() => {
                this.steps = _.without(this.steps, step);
                this.currentStep = this.getCurrentStep();
            });
        }
    }

    module.exports = {
        multiple: true,
        controllerAs: "vm",
        focusOnOpen: false,
        bindToController: true,
        parent: $(document.body),
        clickOutsideToClose: true,
        controller: PlanProcedureStepsDialogCtrl,
        template: require("../views/plan-procedure-steps-dialog.tpl.html"),
    };


})();
